import { render, staticRenderFns } from "./StandardSpec.vue?vue&type=template&id=3151b840&scoped=true&"
import script from "./StandardSpec.vue?vue&type=script&lang=js&"
export * from "./StandardSpec.vue?vue&type=script&lang=js&"
import style0 from "./StandardSpec.vue?vue&type=style&index=0&id=3151b840&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3151b840",
  null
  
)

export default component.exports